import { useState } from "react";
import { Breadcrumb, Button } from "flowbite-react";
import type { FC } from "react";
import { HiHome } from "react-icons/hi";
import NavbarSidebarLayout from "../../layouts/navbar-sidebar";
import TicketManagement from "./TicketManagement";
import CreateTicket from "../TicketFormDialog"; // Import CreateTicket modal
import { FormProvider, SubmitHandler, useForm } from "react-hook-form";
import { useCreateTicketMutation } from "@/api/ticketApi/ticket";
import { toast } from "@/lib/toast";
import { getErrorMessage } from "@/utils/requestUtils";
import { useTranslation } from "react-i18next";

const TicketDashboard: FC = function () {
  const [isCreateTicketOpen, setIsCreateTicketOpen] = useState(false);
  const { t } = useTranslation("ticket");
  const { t: tCommon } = useTranslation("common");

  const defaultValues = {
    ticket_title: "",
    ticket_description: "",
    last_priority_id: null,
    last_category_id: null,
    client_id: null,
    last_assigned_agent_id: null,
  };

  const methods = useForm({
    defaultValues,
  });

  const [createTicket, { isLoading }] = useCreateTicketMutation();

  const handleSubmit: SubmitHandler<any> = async (data) => {
    await createTicket({
      ...data,
    })
      .unwrap()
      .then(() => {
        methods.reset();
        toast.success(t("ticketList.toast.success"));
        setIsCreateTicketOpen(false);
      })
      .catch((error: any) => {
        toast.error(` ${getErrorMessage(error)}`);
      });
  };

  return (
    <NavbarSidebarLayout>
      <div className="h-screen overflow-y-auto pb-20">
        <div className="mb-6 grid grid-cols-1 gap-y-6 px-4 pt-6 dark:border-gray-700 dark:bg-gray-900">
          <div className="col-span-full">
            <Breadcrumb className="mb-4">
              <Breadcrumb.Item href="/">
                <div className="flex items-center gap-x-3">
                  <HiHome className="text-xl" />
                  <span className="dark:text-white">{tCommon("home")}</span>
                </div>
              </Breadcrumb.Item>

              <Breadcrumb.Item>{tCommon("tickets")}</Breadcrumb.Item>
            </Breadcrumb>
            <div className="flex items-center justify-between">
              <h1 className="text-xl font-semibold text-gray-900 dark:text-white sm:text-2xl">
                {tCommon("tickets")}
              </h1>
              <div>
                <Button
                  color="primary"
                  className="inline-flex w-full items-center justify-center rounded-lg text-center text-sm font-medium text-white sm:w-auto"
                  onClick={() => setIsCreateTicketOpen(true)}
                >
                  <svg
                    className="-ml-1 mr-2 h-5 w-5"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z"
                      clipRule="evenodd"
                    />
                  </svg>
                  {t("ticketList.createTicket")}
                </Button>
              </div>
            </div>
          </div>
          <TicketManagement />
          {/* <TicketHistory /> */}
        </div>
        <div className="grid grid-cols-1 gap-y-6 px-4">
          {/* <GeneralInfoCard /> */}
        </div>
      </div>
      <FormProvider {...methods}>
        <CreateTicket
          open={isCreateTicketOpen}
          onClose={() => setIsCreateTicketOpen(false)}
          mode="create"
          onSubmit={handleSubmit}
          isLoading={isLoading}
        />
      </FormProvider>
    </NavbarSidebarLayout>
  );
};

export default TicketDashboard;
